import { defineMessages } from 'react-intl';

export default defineMessages({
  LOGOUT: {
    defaultMessage: 'Déconnexion',
  },
  PROFILE_PRIVATE: {
    defaultMessage: 'Privé',
  },
} as const);
